import { apiClient } from 'api/client/apiClient';
import { DeleteApplicationApiKeyParams } from '../types';
import { API_URLS } from '../consts';

export const deleteApplicationApiKey = async ({ apiKeyId, applicationId }: DeleteApplicationApiKeyParams) => {
  const result = await apiClient.delete(`${API_URLS.Applications}/applications/${applicationId}/api-keys/${apiKeyId}`);

  return result.data;
};
